import {html, css, LitElement} from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import {customElement, property, query} from 'lit/decorators.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { TConversation } from './vxc_conversation'
import { TIAmie } from './wrappers/iamie'

//import * as Types from './vx_chat.d'

const Default = {
    Header: 'Chat BOT',
    Footer: 'powered by <b>VOXYMORE</b>',
    Invite: 'ask anything..',
    Styles: {}
}

@customElement('vxc-chatbot')
export class TChatBot extends LitElement {
    public  sid  : String | null = null  
    private engine : TIAmie|null = null
    static styles = css`
            :host {
                --vx-chat-primary-bg-color: #42a5f5;
                --vx-chat-secondary-color: #03dac6;
                --vx-chat-primary-text-color: #fff;
                --vx-chat-body-bg-color: #fff;
                --vx-toggle-button-radius: 5rem;
                --vx-toggle-button-pos-right: 3rem;
                --vx-toogle-button-pos-bottom: 3rem;
                --vx-toogle-button-hover-shadow: 0 0 6px 2px #CCC;
                --vx-chat-widget-pos-right: .5rem;
                --vx-chat-widget-pos-bottom: .5rem;
                --vx-chat-widget-width: 450px;
                --vx-chat-widget-height: 800px;
                --vx-chat-widget-border-radius: 10px;
                --vx-default-font-family: "Montserrat", sans-serif;   
                --vx-chat-bot-bubble-background: #D6ECF7;
                --vx-chat-user-bubble-background: white;             
                --vx-toggle-button-icon: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" x="0px" y="0px" fill="white"><path d="m50,29.28c-15.28,0-24.19,3.83-26.25,7.62-2.98,5.5-2.98,19.02,0,24.52,2.06,3.79,10.97,7.62,26.25,7.62s24.19-3.83,26.25-7.63c2.98-5.5,2.98-19.02,0-24.51-2.06-3.79-10.97-7.62-26.25-7.62Zm25.37,8.1c2.86,5.29,2.86,18.28,0,23.56-1.85,3.42-10.58,7.1-25.37,7.1s-23.51-3.68-25.37-7.1c-2.86-5.29-2.86-18.28,0-23.56,1.85-3.42,10.58-7.1,25.37-7.1s23.51,3.68,25.37,7.1Zm-43.47,26.11c-.08.2-.27.33-.47.33-.06,0-.12,0-.17-.03-2.81-1.05-4.86-2.36-5.48-3.51-.74-1.37-1.31-3.44-1.63-5.98-.03-.27.16-.52.43-.56.27-.04.52.16.56.43.31,2.42.83,4.36,1.51,5.63.38.7,1.9,1.92,4.95,3.05.26.1.39.38.29.64Zm16.72-18.15v7.65c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-7.65c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5Zm7.21-1.24v10.13c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-10.13c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5Zm17.66,33.53c.05.16-.03.33-.18.4s-.33.01-.42-.13c-.48-.81-1.04-1.55-1.68-2.21-3.59,4.82-10.51,8.4-18.49,9.57-.85.12-1.63-.46-1.72-1.31v-.02c-.09-.81.49-1.51,1.29-1.63,7.18-1.07,13.52-4.3,16.58-8.49-.23-.14-.47-.27-.71-.4-.15-.08-.22-.25-.16-.41s.23-.24.39-.2c2.33.61,4.35,2.54,5.09,4.83Zm13.73-31.92c-.55-3.54-1.38-6.55-2.39-8.76-5.25-11.4-18.49-13.7-31.52-13.99,0-.99-1.74-2.78-2.1-3.72,1.21.04,3.79,1.42,4.56.56.78-.86-.79-3.27-.98-4.49.59.17,2.07,1.21,2.83,1.6,1.18,1.46,2.98,2.41,5.01,2.41,3.54,0,6.42-2.87,6.42-6.41s-2.88-6.41-6.42-6.41-6.42,2.87-6.42,6.41c0,.79.15,1.54.41,2.23-1.07-.66-1.98-1.14-2.55-.65-.96.82.89,3.42.94,4.6-1.04.08-3.92-1.53-4.68-.49-.74,1.03,1.64,3.18,1.98,4.26-.11.03-.28.05-.48.07-.88-.01-1.32-.01-1.93-.01-.48,0-2.49.02-3.29.04-.35-2.42-2.42-4.31-6.1-5.52.23-3.43-2.84-5.86-5.94-5.24-2.71.54-4.47,3.16-3.93,5.87.54,2.7,3.18,4.46,5.88,3.92,1.74-.35,3.27-1.59,3.82-3.56,3.16,1.06,4.92,2.59,5.27,4.56-12.67.4-25.32,2.89-30.42,13.96-1.02,2.21-1.84,5.22-2.39,8.76-4.62.4-8.28,4.81-8.28,10.17s3.5,9.58,7.97,10.14c.54,4.52,1.46,8.3,2.7,10.99,5.68,12.35,20.75,14.03,34.76,14.03,1.89,1.55,4.91,2.45,8.23,2.45,4.44,0,8.22-1.64,9.63-4.07,8.54-2.02,14.11-6.09,17.02-12.41,1.24-2.69,2.17-6.47,2.7-10.99,4.48-.56,7.97-4.9,7.97-10.14s-3.66-9.78-8.28-10.17ZM62.61,9.5c1.89,0,3.42,1.53,3.42,3.41s-1.53,3.41-3.42,3.41-3.42-1.53-3.42-3.41,1.53-3.41,3.42-3.41Zm-26.69,9.55c-1.07.21-2.14-.49-2.35-1.56-.24-1.23.7-2.38,1.96-2.38.93,0,1.77.66,1.96,1.6.22,1.08-.49,2.13-1.57,2.34ZM7.5,55.88c0-3.76,2.4-7.57,7.07-7.12.82,5.58.93,8.98.07,14.26-5.64.32-7.14-4.35-7.14-7.14Zm74.6,19.88c-3.12,6.77-9.36,9.52-16.5,11.08l-.27.81c-.46,1.37-3.33,2.85-7.17,2.85-2.65,0-5.15-.6-7.04-2.46-12.59.01-27.95-.82-33.22-12.29-1.19-2.58-2.06-6.37-2.54-10.99,1.2-6.5,1.1-10.23.12-16.72.41-3.08,1.06-6.88,2.42-9.85,2.8-6.07,8.8-12.28,32.1-12.28,13.08,0,27.12,1.46,32.1,12.28,1.47,3.2,2.08,7.26,2.5,10.43-.93,5.67-.78,9.32.13,15.34-.37,3.72-1.05,8.37-2.63,11.78Zm3.5-12.72c-.8-5.54-.9-8.94,0-14.29,4.37-.42,6.91,3.27,6.91,7.14,0,2.7-1.52,7.46-6.9,7.16ZM13.32,49.86c.1.26-.04.55-.29.64-1.18.44-2.17,1.26-2.79,2.34-.09.16-.26.25-.43.25-.09,0-.17-.02-.25-.07-.24-.14-.32-.44-.18-.68.74-1.27,1.92-2.25,3.31-2.77.26-.1.55.04.64.3Zm77.6,3.11c.09.26-.04.55-.3.64-.06.02-.11.03-.17.03-.21,0-.4-.13-.47-.33-.43-1.2-1.24-2.21-2.29-2.85-.24-.14-.31-.45-.17-.69.14-.24.45-.31.69-.17,1.25.75,2.21,1.95,2.72,3.37Z"/></svg>');
                --vx-chat-bot-icon     : url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" x="0px" y="0px"><path d="m50,29.28c-15.28,0-24.19,3.83-26.25,7.62-2.98,5.5-2.98,19.02,0,24.52,2.06,3.79,10.97,7.62,26.25,7.62s24.19-3.83,26.25-7.63c2.98-5.5,2.98-19.02,0-24.51-2.06-3.79-10.97-7.62-26.25-7.62Zm25.37,8.1c2.86,5.29,2.86,18.28,0,23.56-1.85,3.42-10.58,7.1-25.37,7.1s-23.51-3.68-25.37-7.1c-2.86-5.29-2.86-18.28,0-23.56,1.85-3.42,10.58-7.1,25.37-7.1s23.51,3.68,25.37,7.1Zm-43.47,26.11c-.08.2-.27.33-.47.33-.06,0-.12,0-.17-.03-2.81-1.05-4.86-2.36-5.48-3.51-.74-1.37-1.31-3.44-1.63-5.98-.03-.27.16-.52.43-.56.27-.04.52.16.56.43.31,2.42.83,4.36,1.51,5.63.38.7,1.9,1.92,4.95,3.05.26.1.39.38.29.64Zm16.72-18.15v7.65c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-7.65c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5Zm7.21-1.24v10.13c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-10.13c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5Zm17.66,33.53c.05.16-.03.33-.18.4s-.33.01-.42-.13c-.48-.81-1.04-1.55-1.68-2.21-3.59,4.82-10.51,8.4-18.49,9.57-.85.12-1.63-.46-1.72-1.31v-.02c-.09-.81.49-1.51,1.29-1.63,7.18-1.07,13.52-4.3,16.58-8.49-.23-.14-.47-.27-.71-.4-.15-.08-.22-.25-.16-.41s.23-.24.39-.2c2.33.61,4.35,2.54,5.09,4.83Zm13.73-31.92c-.55-3.54-1.38-6.55-2.39-8.76-5.25-11.4-18.49-13.7-31.52-13.99,0-.99-1.74-2.78-2.1-3.72,1.21.04,3.79,1.42,4.56.56.78-.86-.79-3.27-.98-4.49.59.17,2.07,1.21,2.83,1.6,1.18,1.46,2.98,2.41,5.01,2.41,3.54,0,6.42-2.87,6.42-6.41s-2.88-6.41-6.42-6.41-6.42,2.87-6.42,6.41c0,.79.15,1.54.41,2.23-1.07-.66-1.98-1.14-2.55-.65-.96.82.89,3.42.94,4.6-1.04.08-3.92-1.53-4.68-.49-.74,1.03,1.64,3.18,1.98,4.26-.11.03-.28.05-.48.07-.88-.01-1.32-.01-1.93-.01-.48,0-2.49.02-3.29.04-.35-2.42-2.42-4.31-6.1-5.52.23-3.43-2.84-5.86-5.94-5.24-2.71.54-4.47,3.16-3.93,5.87.54,2.7,3.18,4.46,5.88,3.92,1.74-.35,3.27-1.59,3.82-3.56,3.16,1.06,4.92,2.59,5.27,4.56-12.67.4-25.32,2.89-30.42,13.96-1.02,2.21-1.84,5.22-2.39,8.76-4.62.4-8.28,4.81-8.28,10.17s3.5,9.58,7.97,10.14c.54,4.52,1.46,8.3,2.7,10.99,5.68,12.35,20.75,14.03,34.76,14.03,1.89,1.55,4.91,2.45,8.23,2.45,4.44,0,8.22-1.64,9.63-4.07,8.54-2.02,14.11-6.09,17.02-12.41,1.24-2.69,2.17-6.47,2.7-10.99,4.48-.56,7.97-4.9,7.97-10.14s-3.66-9.78-8.28-10.17ZM62.61,9.5c1.89,0,3.42,1.53,3.42,3.41s-1.53,3.41-3.42,3.41-3.42-1.53-3.42-3.41,1.53-3.41,3.42-3.41Zm-26.69,9.55c-1.07.21-2.14-.49-2.35-1.56-.24-1.23.7-2.38,1.96-2.38.93,0,1.77.66,1.96,1.6.22,1.08-.49,2.13-1.57,2.34ZM7.5,55.88c0-3.76,2.4-7.57,7.07-7.12.82,5.58.93,8.98.07,14.26-5.64.32-7.14-4.35-7.14-7.14Zm74.6,19.88c-3.12,6.77-9.36,9.52-16.5,11.08l-.27.81c-.46,1.37-3.33,2.85-7.17,2.85-2.65,0-5.15-.6-7.04-2.46-12.59.01-27.95-.82-33.22-12.29-1.19-2.58-2.06-6.37-2.54-10.99,1.2-6.5,1.1-10.23.12-16.72.41-3.08,1.06-6.88,2.42-9.85,2.8-6.07,8.8-12.28,32.1-12.28,13.08,0,27.12,1.46,32.1,12.28,1.47,3.2,2.08,7.26,2.5,10.43-.93,5.67-.78,9.32.13,15.34-.37,3.72-1.05,8.37-2.63,11.78Zm3.5-12.72c-.8-5.54-.9-8.94,0-14.29,4.37-.42,6.91,3.27,6.91,7.14,0,2.7-1.52,7.46-6.9,7.16ZM13.32,49.86c.1.26-.04.55-.29.64-1.18.44-2.17,1.26-2.79,2.34-.09.16-.26.25-.43.25-.09,0-.17-.02-.25-.07-.24-.14-.32-.44-.18-.68.74-1.27,1.92-2.25,3.31-2.77.26-.1.55.04.64.3Zm77.6,3.11c.09.26-.04.55-.3.64-.06.02-.11.03-.17.03-.21,0-.4-.13-.47-.33-.43-1.2-1.24-2.21-2.29-2.85-.24-.14-.31-.45-.17-.69.14-.24.45-.31.69-.17,1.25.75,2.21,1.95,2.72,3.37Z"/></svg>');
                --vx-chat-user-icon    : url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5.0 -10.0 110.0 135.0"><path d="m70 12.5c1.3789 0 2.5 1.1211 2.5 2.5v26.668c0 4.4492-0.92969 8.4531-2.7539 11.832-1.8281 3.3945-4.5195 6.0859-7.9102 7.9141-3.3789 1.8203-7.3867 2.7539-11.836 2.7539s-8.457-0.93359-11.836-2.7539c-3.3906-1.8281-6.082-4.5195-7.9102-7.9141-1.8242-3.3789-2.7539-7.3828-2.7539-11.832v-5.2773c0-5.7305 0.83203-9.6172 2.7461-13.191 1.8281-3.4219 4.5312-6.125 7.9531-7.9531 3.5742-1.9141 7.4609-2.7461 13.191-2.7461zm-2.5 5h-16.109c-4.9609 0-8.043 0.66016-10.832 2.1523-2.5508 1.3672-4.5391 3.3555-5.9062 5.9062-1.4922 2.7891-2.1523 5.8711-2.1523 10.832v5.2773c0 3.6484 0.74219 6.8398 2.1523 9.4609 1.3672 2.5312 3.3516 4.5195 5.8867 5.8828 2.6172 1.4141 5.8125 2.1562 9.4609 2.1562s6.8438-0.74219 9.4609-2.1562c2.5352-1.3633 4.5195-3.3516 5.8867-5.8828 1.4102-2.6211 2.1523-5.8125 2.1523-9.4609zm-8.4922 29.395c0.79688 1.293 0.39453 2.9844-0.90234 3.7812-2.1719 1.3359-5.0625 2.0742-8.1094 2.0742-3.043 0-5.9258-0.73438-8.1016-2.0664-1.293-0.79688-1.6992-2.4883-0.90625-3.7812 0.79297-1.2969 2.4883-1.7031 3.7812-0.91016 1.2656 0.77734 3.1562 1.2578 5.2266 1.2578 2.0742 0 3.9688-0.48438 5.2305-1.2578 1.293-0.79688 2.9883-0.39453 3.7812 0.90234zm-8.9023 22.25c14.766 0 28.277 4.7227 36.047 12.461 0.98047 0.97656 0.98047 2.5586 0.007812 3.5352-0.97266 0.98047-2.5586 0.98438-3.5352 0.007813-6.7539-6.7266-18.992-11.004-32.52-11.004-13.531 0-25.773 4.2812-32.523 11.012-0.97656 0.97656-2.5625 0.97266-3.5352-0.003906-0.97656-0.98047-0.97266-2.5625 0.003906-3.5352 7.7695-7.7461 21.285-12.473 36.055-12.473z" /></svg>');
                --vx-chat-send-icon    : url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0"><path d="m61.301 46.699c0.5 0 1 0.5 1 1-0.10156 0.60156-0.5 1-1.1016 1l-28.398-1c-0.60156 0-1-0.5-1-1 0-0.39844 0.30078-0.80078 0.60156-0.89844l51.602-25.398c0.5-0.30078 1.1016-0.10156 1.3008 0.39844 0.10156 0.19922 0.19922 0.39844 0.10156 0.5l-1.8984 28.801-1.8984 28.699c0 0.5-0.5 1-1 0.89844-0.19922 0-0.39844-0.10156-0.60156-0.19922l-12.102-8.1016c-0.39844-0.30078-0.5-0.89844-0.19922-1.3984 0.30078-0.39844 0.89844-0.5 1.3984-0.19922l10.602 7.1016 3.6016-54-24.199 12-22.301 10.898 24.5 0.89844z"/><path d="m64.398 54.602c0.19922-0.5 0.80078-0.69922 1.3008-0.5 0.5 0.19922 0.80078 0.69922 0.60156 1.3008-2 4.6992-5 8.8984-9 12.199-3.8008 3.1992-8.5 5.5-13.699 6.5-5.1992 1-10.602 0.69922-15.602-0.80078s-9.6016-4.1016-13.199-7.8008c-0.39844-0.39844-0.30078-1 0.10156-1.3984 0.30078-0.39844 1-0.39844 1.3984 0 3.3008 3.3984 7.6016 5.8984 12.301 7.3008 4.6016 1.3984 9.6992 1.6992 14.699 0.69922 4.8008-0.89844 9.1992-3.1016 12.699-6 3.6992-3.1016 6.6016-7 8.3984-11.5z"/></svg>');
            }

            * {
                font-family: "Montserrat", sans-serif;
                font-weight: 400;
                font-style: normal;
                xcolor: black;
            }

            .widget {
                position: fixed;
                font-weight: 400;
                bottom: var(--vx-chat-widget-pos-bottom);
                right: var(--vx-chat-widget-pos-right);
                width: var(--vx-chat-widget-width);
                height: var(--vx-chat-widget-height);
                max-height: 85vh;
                max-width: 95vw;
                border: 1px solid #ccc;
                border-radius: var(--vx-chat-widget-border-radius);
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                background-color: var(--vx-chat-body-bg-color);
                z-index: 1001;
            }
            
            .widget .container {
                display: flex;
                height: 100%;
                flex-direction: column;
            }
                
            .widget .header {
                padding: 10px;
                background-color: var(--vx-chat-primary-bg-color);
                color: var(--vx-chat-primary-text-color);
                font-weight: 600;
                border-radius: var(--vx-chat-widget-border-radius) var(--vx-chat-widget-border-radius) 0 0;
                display: flex;
                justify-content: space-between;
                align-items: center;

            }
                
            .widget .main {
                flex-grow: 1;
                overflow-y: auto;
            }
                
            .widget .footer {
                padding: 10px;
                background-color: var(--vx-chat-primary-bg-color);
                color: var(--vx-chat-primary-text-color);
                border-radius: 0 0 var(--vx-chat-widget-border-radius) var(--vx-chat-widget-border-radius);
                display: flex;
            } 

            .widget .input {
                padding: 2px 5px 2px 5px;
            }

            .widget .header .close-btn {
                cursor: pointer;
                font-size: 20px;
            }

            .input-group {
                display: flex;
                align-items: center;
                border: 1px solid #ced4da;
                border-radius: 0.5rem;
                overflow: hidden;
            }

            .form-control {
                flex: 1;
                border: none;
                padding: 0.375rem 0.75rem;
                font-size: 1rem;
                line-height: 1.5;
                background-clip: padding-box;
            }

            .form-control:focus {
                outline: none;
            }

            .btn-send {
                background-color: transparent;
                background-image: var(--vx-chat-send-icon);
                background-repeat: no-repeat;
                background-position: center;
                background-size: 80%;
                height: 2rem;
                width: 2rem;
                border: none;
                padding: 0.375rem 0.75rem;
                cursor: pointer;
            }

            .btn-send:focus {
                outline: none;
            }

            .btn-send svg {
                width: 20px;
                height: 20px;
                fill: #6c757d;
            }


            .dialog {
                padding: .5rem;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
            }

            .chat-toggle-btn {
                position: fixed;
                bottom: var(--vx-toogle-button-pos-bottom);
                right: var(--vx-toggle-button-pos-right);
                border: none;
                border-radius: 50%;
                height: var(--vx-toggle-button-radius);
                width: var(--vx-toggle-button-radius);
                background-color: var(--vx-chat-primary-bg-color);
                background-image: var(--vx-toggle-button-icon);
                background-repeat: no-repeat;
                background-position: center;
                background-size: 70%;
                color: var(--vx-chat-primary-text-color);
                cursor: pointer;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                z-index: 1000;
            }

            .chat-toggle-btn:hover {
                box-shadow: var(--vx-toogle-button-hover-shadow);
            }

            .visible {
                display: block;
            }

            .hidden {
                display: none;
            }
        `
    /** properties */
    @property({ type: Boolean                   }) 	   show : boolean = false
    @property({ type: Boolean                   })     enableReview: boolean = false
    @property({ type: Boolean                   })     enableAttachments: boolean = false
    @property({ type: Boolean                   })     showAttachmentsContent: boolean = false
    @property({ type: String                    })     host: string = ''
    @property({ type: String                    })     app: string = ''
    @property({ type: Object, attribute: 'data' })     sessionData: Record<string,any> = {}
    @property({ type: String                    })     header: string = Default.Header
    @property({ type: String                    })     footer: string = Default.Footer
    @property({ type: String                    })     invite: string = Default.Invite   
    @property({ type: Object                    })     styles: Record<string,any> = Default.Styles
    @query('vxc-conversation') private conversation!: TConversation
    @query('#user-input') private question!: HTMLInputElement

    constructor() {
        super()
    }

    updated(changedProperties: Map<string | number | symbol, unknown>): void {
        if (changedProperties.has('app') && this.app?.length) {
            // console.log(`'app' changed from ${changedProperties.get('app')} to ${this.app}`);
            this.loadApp()
        }
        if (changedProperties.has('styles')) {
            // setup the styles
            console.log('setting up styles')
            for (const [key, value] of Object.entries(this.styles)) {
                // console.log(key, value)
                this.style.setProperty(key, value)
            }
        }
        // console.log('chat bot updated', this.show)
        super.updated(changedProperties)
    }

    private async loadApp() {
        try {
            this.engine = null
            // this.style.setProperty(`--vx-chat-primary-bg-color`, 'red')
            // console.log('loading app', `${this.host}/apps/${this.app}`)
            if(!this.app) throw new Error('no app to load')
            const resp = await fetch(`${this.host}/apps/${this.app}`)
            if(!resp.ok) throw new Error(`Error: ${resp.statusText}`)
            const data = await resp.json()
            if(data?.uid !== this.app) throw new Error('app not found..')
            console.log('app', data)
            const websrc = data.sources.find( (src: { type: string }) => src.type === 'web')
            if(websrc) 
                this.dispatchEvent(new CustomEvent('domain', { detail: websrc.settings.domain, bubbles: true, composed: true } ))

            const layout = data.layout || {}
            if(layout.header)     this.header = layout.header 
            if(layout.footer)     this.footer = layout.footer 
            if(layout.invite)     this.invite = layout.invite
            if(layout.styles)     this.styles = layout.styles
            this.engine = new TIAmie(this.app, this.sessionData, this.host)

            // console.log('session storage', sessionStorage.getItem('voxy-ai-chat-session-uid'))
            
            // if(sessionStorage.getItem('voxy-ai-chat-session-uid') !== null)
            //     this.createSession()

        } 
        catch (e) { console.error('Failed to load application', e) }
    } 

    private async createSession() {
        // console.log('creating session', this.engine)
        try {
            if(this.engine) {
                console.log("creating session")
                var sid = sessionStorage.getItem('voxy-ai-chat-session-uid')
                var session = await this.engine.start(sid)
                if(!session?.uid) throw new Error('session failed to start..')
                console.log('session :', session.uid)
                this.sid = session.uid
                this.conversation.dialog = session.dialog
                this.show = true
                sessionStorage.setItem('voxy-ai-chat-session-uid', session.uid)
                console.log('session storage', sessionStorage.getItem('voxy-ai-chat-session-uid'))
                console.log('chat bot show', this.show)
            }
        }
        catch(e) { console.error(e) }
    }

    private async closeSession() {
        // TODO: close session here 
        sessionStorage.removeItem('voxy-ai-chat-session-uid')
        this.conversation.clear()
        this.show = false
        // console.log('chat bot show', this.show)
    }

    private toggleModal() : void {
        // console.log('toggle modal')
        this.show ? this.closeSession() : this.createSession()
                console.log('chat bot show', this.show)
    }


    private processChunk(chunk:any){
        try {
            // console.log('got Chunk', chunk)
            this.conversation?.addChunk(chunk)
        }
        catch(e) { console.error(e) }
    }

    private async sendQuestion() {
        try {
            var self = this
            let q = this.question?.value
            this.question.value = ''
            // console.log('question', this.question)
            // console.log('value', this.question.value)
            if(q?.length) {
                // console.log('sending question :', q)
                this.conversation.createExchange({type: 'text', content: q})
                await this.engine?.ask(q, 
                    (chunk) => self.processChunk(chunk), 
                    () => console.log('done'), 
                    (e) => console.error(e) )
            }
        }
        catch(e) { console.error(e) }
    }

    private async sendReview(event: CustomEvent) {
        // console.log('sending review', event.detail)
        try {
            if(!event.detail?.xid) throw new Error('no exchange id given..')
            if(!event.detail?.rating) throw new Error('rating must be postiive or negative..')
            const payload = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({sender: '', rating: event.detail.rating, comment: event.detail.comment})
            }
            const resp = await fetch(`${this.host}/apps/${this.app}/chat/${this.sid}/exchanges/${event.detail.xid}`, payload)
            if(!resp.ok) throw new Error(`Error: ${resp.statusText}`)
            const body = await resp.json()
            // console.dir("rating reply :", body)
        }
        catch(e) { console.error(e) }
    }

    private _handleKeyPress(e: KeyboardEvent) {
        if (e.key === 'Enter') this.sendQuestion()
    }

    /**
     * render function
     * @returns html
     */
    render() {
        const WidgetVisibilityClass = {
            'visible': this.show||false,
            'hidden' : !(this.show||false)
        }
        // console.log('chat bot visible', this.show)
        const dom = html`
        <div class="widget ${classMap(WidgetVisibilityClass)}">
            <div class="container">
                <div class="header">
                    ${unsafeHTML(this.header)}
                    <span id="close-btn" class="close-btn" @click="${this.toggleModal}">&times;</span>
                </div>

                <vxc-conversation 
                    class="main"
                    @review=${this.sendReview}
                    ?enableReview=${this.enableReview}
                    ?enableAttachments=${this.enableAttachments}
                    ?showAttachmentsContent=${this.showAttachmentsContent}
                ></vxc-conversation>

                <div class="input">
                    <div class="input-group">
                        <input id="user-input" type="text" class="form-control" placeholder="${this.invite || 'Type your message...'}" dir="auto" @keypress=${this._handleKeyPress}>
                        <button class="btn-send" @click=${this.sendQuestion}></button>
                    </div>
                </div>
                <div class="footer">
                    ${unsafeHTML(this.footer||'')}
                </div>
            </div>
        </div>
        <button 
            class="chat-toggle-btn" 
            @click=${this.toggleModal}>
        </button>
        `
        // console.dir(this.dialog)
        return dom
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-chatbot': TChatBot;
  }
}